import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AddPhotoImageData } from "common/types";
import User from "../../../types/user";
import { flagVenueReviewDesktop, flagVenueReviewMobile } from "../../../apis";

export function useFlagReview(isMobile?: boolean) {
  const queryClient = useQueryClient();
  const { mutate, error, status, data } = useMutation({
    mutationFn: ({
      reviewId,
      accessToken,
      notes,
      images,
    }: {
      reviewId: string;
      accessToken: string;
      notes: string;
      images: AddPhotoImageData[];
    }) => {
      if (isMobile) {
        return flagVenueReviewMobile(reviewId, accessToken, notes, images);
      } else {
        return flagVenueReviewDesktop(reviewId, accessToken, notes, images);
      }
    },
    onSuccess: () => {},
  });
  return { mutate, error, isPending: status === "pending", data };
}
